// ECMAScript polyfills
import 'core-js/fn/array/find';
import 'core-js/fn/array/from';
import 'core-js/fn/object/assign';
import 'core-js/fn/promise';
import 'core-js/fn/string/code-point-at';
import 'core-js/fn/string/from-code-point';
import 'core-js/fn/symbol';

// Browser polyfills
import './polyfills/custom_event';
import './polyfills/element';



// WEBPACK FOOTER //
// ./commons/polyfills.js